/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-10-20 17:50:05
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-11 11:55:59
 * @FilePath: /designcenter/src/api/modules/user.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes, IResList, IPage } from '@/types'

const request = getApiRequest()

//获取用户信息
export async function getUserInfo() {
  return request.post<IRes<IResList<unknown>>>('/collector/api/user/info?getMore=1&get_system_messages=1')
}

//获取用户类型
export async function getUserType() {
  return request.get<IRes<IResList<unknown>>>('/design/customer/getCustomerType')
}

export async function getCustomerType() {
  return getUserType()
}

// feedback
export async function feedback(data: any) {
  return request.post<IRes<IResList<unknown>>>('/api/feedback_submit', data)
}

//记录用户登录
export async function userLoginLog(query: any) {
  return request.get<IRes<IResList<unknown>>>('/design/customer/recordLogin', { params: query })
}

export async function recordLogin(query: any) {
  return userLoginLog(query)
}
